<template>

<div class="foot-ct">
    <div class="link" v-if="!Config.hiddenAuths.includes('foot-link')">
        <Row>
            <Col :xs="{ span: 8}" :lg="{ span: 8}">
            <div class="foot-title">{{$t('footer_ecology')}}</div>
            <div class="foot-list">
                <a class="text-link" target="_blank" href="https://www.bytetrade.io/">{{$t('footer_ecology_bytetradeblockchain')}}</a>
            </div>
            <div class="foot-list">
                <a class="text-link" target="_blank" href="https://play.google.com/store/apps/details?id=com.bytetrade.bytehub">{{$t('footer_ecology_downloadclients')}}</a>
            </div>
            <div class="foot-list">
                <a class="text-link" target="_blank" href="https://medium.com/@bytetrade/pitio-hide-the-complexity-for-a-simplicable-decentralized-exchange-ef38afc6e06b">{{$t('footer_ecology_pitiopaymentprotocal')}}</a>
            </div>

            </Col>
            <Col :xs="{ span: 6}" :lg="{ span: 6 }">
            <div class="foot-title">{{$t('footer_support')}}</div>
            <div class="foot-list">
                <a class="text-link" target="_blank" href="https://bytetrade.zendesk.com/hc/en-gb/articles/360026040891-ByteHub-Deposit-Withdraw">{{$t('footer_support_deposit')}}</a>
            </div>
            <div class="foot-list">
                <a class="text-link" target="_blank" href="https://bytetrade.zendesk.com/hc/en-gb/articles/360026040891-ByteHub-Deposit-Withdraw">{{$t('footer_support_withdraw')}}</a>
            </div>
            <div class="foot-list">
                <a class="text-link" target="_blank" href="https://bytetrade.zendesk.com/hc/en-gb/articles/360026035791-Troubleshooting">{{$t('footer_support_fees')}}</a>
            </div>
            <div class="foot-list">
                <a class="text-link" target="_blank" href="https:/bytetrade.zendesk.com">{{$t('footer_support_more')}}</a>
            </div>

            </Col>

            <Col :xs="{ span: 7}" :lg="{ span: 7}">
            <div class="foot-title">{{$t('footer_contact')}}</div>
            <div class="foot-list">
                <a class="text-link" href="mailto:support@bytetrade.io">{{$t('footer_contact_listtoken')}}</a>
            </div>
            <div class="foot-list">
                <a class="text-link" href="mailto:support@bytetrade.io">{{$t('footer_contact')}}</a>
            </div>

            </Col>
            <Col :xs="{ span: 3}" :lg="{ span: 3 }">
            <div class="foot-title">{{$t('footer_socialmedia')}}</div>
            <Row class="foot-soc-icon">
                <Col :xs="{ span: 6}" :lg="{ span: 6 }">
                <a target="_blank" href="https://www.facebook.com/bytetrade.global"><img src="../../assets/image/index/twitter.png"></a></Col>
                <Col :xs="{ span: 6}" :lg="{ span: 6 }">
                <a target="_blank" href="https://www.facebook.com/bytetrade.global"><img src="../../assets/image/index/facebook.png"></a>
                </Col>

                <Col :xs="{ span: 6}" :lg="{ span: 6 }">
                <a target="_blank" href="https://t.me/Bytetrade_cn">
                    <img src="../../assets/image/index/telegram.png">
                </a>
                </Col>

                <Col :xs="{ span: 6}" :lg="{ span: 6 }">
                <a target="_blank" href="https://medium.com/@bytetrade">
                    <img src="../../assets/image/index/fenzu6.png">
                </a>
                </Col>
            </Row>
            </Col>
        </Row>

    </div>
    <div v-if="!Config.hiddenAuths.includes('foot-link')" class="foot-line"></div>
    <Row v-if="!Config.hiddenAuths.includes('foot-partner')" class="partner">
        <Col class="partner-logo"><img src="../../assets/image/index/7.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/6.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/5.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/4-1.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/3-p.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/cmt.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/1-2.png"></Col>
    </Row>
    <div v-if="Config.hiddenAuths.includes('foot-partner')" style="margin-top:0.36rem;"></div>

    <div class="copy">©2019 {{Config.WebsiteName}}</div>
</div>
</template>

<script>
import Config from '@/utils/Config';

export default {
    name: 'Footer',
    data () {
        return {
            Config
        }
    }
};
</script>

<style lang="less">
@import "../../../static/style/color.less";
@import "../../../static/style/preset.less";
@import "../../../static/style/lib.less";
@import "../../../static/style/foot.less";
@import "../../../static/style/media.less";
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue